import { mainColor, UNIT } from '../../constants/theme';
import { Theme, createStyles } from '@material-ui/core/styles';

export const styles = (theme?: Theme) => createStyles({
  addIcon: {
    fontSize: UNIT * 2,
    color: mainColor.secondaryColor,
    backgroundColor: 'transparent'
  },
  iconStyle: {
    fontSize: UNIT * 2
  },
  paper: {
    padding: UNIT * 0.625,
    borderRadius: UNIT,
    margin: UNIT * 0.625,
    position: 'relative',
    width: UNIT * 12,
    height: UNIT * 9
  },
  maxPaper: {
    height: UNIT * 10.5
  },
  firstItem: {
    borderRadius: UNIT,
    border: '3px solid',
    borderColor: 'gray',
    margin: UNIT * 0.6875,
    padding: UNIT * 1.25,
    width: UNIT * 12,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center',
    alignItems: 'center',
    borderStyle: 'dashed',
    minHeight: UNIT * 9
  },
  container: {
    flex: 'display',
    width: '100%',
    padding: UNIT * 1.25,
    userSelect: 'none',
    justifyContent: 'center'
  },
  textStyle: {
    margin: 0,
    fontSize: UNIT * 0.75
  },
  body: {
    flex: 'display',
    width: '100%',
    flexDirection: 'column',
    justifyContent: 'center'
  }
});

